import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import EventSaveContainer from '../../views/event/save/EventSaveContainer';
import { EVENT_PAGE_NAME } from '../../constants/service/app/eventConstants';

const EventCreate = () => {
  return (
    <PageTemplate pageName={EVENT_PAGE_NAME.EVENT_CREATE}>
      <EventSaveContainer />
    </PageTemplate>
  );
};

export default EventCreate;
